/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/


type _Schriftart = "ARIMO" | "ROBOTO" | "TINOS" | "OPENSANS"

type Leer = "";

type Schriftart = _Schriftart | Leer;

export default Schriftart;

export class Schriftarten {
    public static readonly arimo: Schriftart = "ARIMO";
    public static readonly roboto: Schriftart = "ROBOTO";
    public static readonly tinos: Schriftart = "TINOS";
    public static readonly openSans: Schriftart = "OPENSANS";
    public static readonly leer: Schriftart = "";
}
